import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useMutation, useQuery } from 'react-query';
import Table from 'react-bootstrap/Table';
import { INVENTORY_SESSION_API } from '@app/utils/apiUrl';
import { Get, Post } from '@app/utils/httpProvider';
import { URI_INTERNAL } from '../../utils/pathLocations';
import { ConfirmModal } from '../../modules/modal/ConfirmModal';

const InventorySessionCreate = () => {
    const history = useHistory();

    const [title, setTitle] = useState('');
    const [notes, setNotes] = useState('');
    const [openConfirmModal, setOpenConfirmModal] = useState(false);

    // 3. Create mutation
    const createMutation = useMutation((payload) =>
        Post(INVENTORY_SESSION_API.CREATE, null, payload)
    );

    const handleConfirmSubmit = () => {
        if (!title.trim()) {
            toast.warn('Vui lòng nhập tiêu đề phiếu kiểm kê');
            return;
        }

        setOpenConfirmModal(true);
    };

    const handleAcceptSubmit = () => {
        const payload = {
            title: title.trim(),
            notes: notes.trim()
        };

        createMutation.mutate(payload, {
            onSuccess: (res) => {
                toast.success('Chốt phiếu kiểm kê thành công!');
                history.push(URI_INTERNAL.INVENTORY_SESSION_PATH);
            },
            onError: (err) => {
                toast.error('Có lỗi xảy ra khi tạo phiếu kiểm kê');
                console.error(err);
            }
        });
        setOpenConfirmModal(false);
    };

    const handleCancelSubmit = () => {
        setOpenConfirmModal(false);
    };

    const goBack = () => {
        history.push(URI_INTERNAL.INVENTORY_SESSION_PATH);
    };

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-lg-12">
                    <div className="card">
                        <div className="card-header bg-white py-3 d-flex justify-content-between align-items-center">
                            <h5 className="card-title fw-bold text-primary mb-0">
                                <i className="fas fa-plus-circle mr-2" />
                                Tạo Phiếu chốt kiểm kê mới
                            </h5>
                            <button type="button" className="btn btn-secondary btn-sm ml-auto" onClick={goBack}>
                                <i className="fas fa-arrow-left mr-1"></i> Quay lại
                            </button>
                        </div>
                        <div className="card-body">
                            {/* Form Nhập liệu */}
                            <div className="row mb-4">
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label className="font-weight-bold">
                                            Tiêu đề phiếu kiểm kê <span className="text-danger">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Ví dụ: Đợt kiểm kê tài sản Quý 3/2026..."
                                            value={title}
                                            onChange={(e) => setTitle(e.target.value)}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label className="font-weight-bold">Ghi chú (Tùy chọn)</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Ghi chú thêm về đợt kiểm kê này..."
                                            value={notes}
                                            onChange={(e) => setNotes(e.target.value)}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="mt-4 text-center">
                                <button
                                    type="button"
                                    className="btn btn-primary px-4 py-2 font-weight-bold shadow-sm"
                                    onClick={handleConfirmSubmit}
                                    disabled={createMutation.isLoading}
                                >
                                    <i className="fas fa-check-circle mr-2"></i>
                                    {createMutation.isLoading ? 'Đang xử lý...' : 'Chốt phiếu kiểm kê'}
                                </button>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <ConfirmModal
                isOpen={openConfirmModal}
                confirmType="save"
                handleAccept={handleAcceptSubmit}
                handleCancel={handleCancelSubmit}
                content={`Bạn có chắc chắn muốn chốt phiếu kiểm kê này? Dữ liệu của toàn bộ tài sản hiện tại sẽ được hệ thống lưu trữ lại (Snapshot) dưới dạng biên bản.`}
            />
        </div>
    );
};

export default InventorySessionCreate;
